import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

// import {vuexCai} from './module/cai/vuexCai';//引入蔡自己内部的状态管理内容

/* 公共state, mutations, actions */
const state = {
    openid:"123",//用户的openid
    access_token:"",//用户本次的access_token
    jssdk:"",//微信jssdk,
    status:{//当前答题状态
        "msg":0,//"基本信息填写1为已填"，
        "leave":0,//"留言信息填写1为已填"，
        "mobile":0,//"手机，姓名1为已填"，
        "isanswer":0,//是否已经答完题,1为已答
        "time":0,//是否在活动时间内，1是在活动时间内
    },
    is_award:-1,
    wx_access_token:"",//微信小程序的access_token，
    activity_id:"",//微信小程序动态信息的activity_id
}
const mutations={
    setOpenid(state,str){//设置openid
        state.openid = str;
    },
    setAccessToken(state,str){//设置access_token
        // console.log(str);
        state.access_token = str;
    },
    setJssdk(state,obj){//设置jssdk
        state.jssdk = obj;
    },
    setStatus(state,obj){//设置状态
        state.status = obj;
    },
    setIsAward(state,num){
        state.is_award = num;
    },
    setWx_access_token(state,{access_token,activity_id}){
        state.wx_access_token = access_token;
        state.activity_id = activity_id;
    }
}
const actions = {
    async getAccessToken({ commit},self) {}
}
export default new Vuex.Store({
    state,mutations,actions,
    // modules: {//引入模块
    //     vuexCai,
    //     vuexQuan,
    //     vuexMing
    // }
})


// WEBPACK FOOTER //
// ./src/vuex/index.js